export default "__VITE_ASSET__xlR7H6$f__"